import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../css/identifierBar.scss";

import PrintIcon from "@mui/icons-material/Print";
import WhatsHotIcon from "@mui/icons-material/Whatshot";
import ExplicitIcon from "@mui/icons-material/Explicit";
import PowerInputIcon from "@mui/icons-material/PowerInput";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
// import FireExtinguisherIcon from "@mui/icons-material/FireExtinguisher";
// import FireExtinguisherIcon from '@mui/icons-material/FireExtinguisher';
import { useHistory } from "react-router-dom";
import { tooltips } from "../popData";
import { PowerInput } from "@mui/icons-material";

let templateIcons = {
  FA: <WhatsHotIcon className="template-icon" />,
  EICR: <ExplicitIcon className="template-icon" />,
  PRINT: <PrintIcon className="template-icon" />,
  FUSE: <PowerInputIcon className="template-icon" />,
  EICR_REMEDIALS: <FormatListNumberedIcon className="template-icon" />,
};

const IdentifierBar = ({
  title,
  back = false,
  backlink = "",
  callbacks = [],
  templateLoading = false,
}) => {
  function goBack() {
    if (backlink) {
      history.push(backlink);
    } else {
      history.goBack();
    }
  }
  const history = useHistory();
  return (
    <div className="identifierBar">
      {back && (
        <div className="backBox">
          <button onClick={goBack}>
            <ArrowBackIcon style={{ fontSize: 25 }} />
          </button>
        </div>
      )}
      <span className="title">{title}</span>

      <div className="cb-icons">
        {templateLoading ? (
          <span className="template-loading">loading...</span>
        ) : null}
        {callbacks.length > 0 &&
          callbacks.map((item, i) => {
            return (
              <button
                title={tooltips[item.name]}
                disabled={templateLoading}
                key={i}
                onClick={() => item.cb(item.name)}
              >
                {templateIcons[item.name]}
              </button>
            );
          })}
      </div>
    </div>
  );
};

export default IdentifierBar;
